import CryptoJS from 'crypto-js'
const keyStr = 'c631521d7bf840e2'
/*防抖*/
export function debounce(fn, delay) {
	let timer;
	return function(...args) {
		if(timer) clearTimeout(timer)
		timer = setTimeout(() => {
			fn.apply(this, args);
		}, delay)
	}
}
/*节流*/
export function throttle(fn, delay) {
	let lastTime = new Date().getTime();
	let currentTime;
	return function(...args) {
		currentTime = new Date().getTime();
		if(currentTime - lastTime < delay) return;
		lastTime = currentTime;
		fn.apply(this, args);
	}
}
//html剔除富文本标签，留下纯文本
export function getSimpleText(html) {
	var re1 = new RegExp("<.+?>","g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
	var msg = html.replace(re1,''); //执行替换成空字符
	return msg;
}

/* istanbul ignore next */
export const on = (function() {
  if (document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()
export function encrypt(word) {
	var key = CryptoJS.enc.Utf8.parse(keyStr)
	var srcs = CryptoJS.enc.Utf8.parse(word)
	var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
	return encrypted.ciphertext.toString()
  }